import { render, staticRenderFns } from "./Mailreport.vue?vue&type=template&id=927c884e&scoped=true&"
import script from "./Mailreport.vue?vue&type=script&lang=js&"
export * from "./Mailreport.vue?vue&type=script&lang=js&"
import style0 from "./Mailreport.vue?vue&type=style&index=0&id=927c884e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "927c884e",
  null
  
)

export default component.exports